// F16 — the Aqana mark, reduced to its silhouette.
//
// One closed loop with rounded terminals, drawn as a single unbroken stroke:
// no lifted pen, no separate crossbar. It reads as an arch, a peak, a roof.
// This is the site's only ornament — it replaces the 65 emoji the landing
// suite used to use as icons.
//
// Square viewBox so the mark can be dropped into any grid cell without the
// caller doing aspect-ratio maths. The 158x190 artwork is centred inside it.
import React from 'react';
import { C } from './tokens';

const ArchMark = ({ size = 24, color = C.ink, opacity = 1, strokeWidth = 15, style = {} }) => (
    <svg
        width={size}
        height={size}
        viewBox="-16 5 190 190"
        aria-hidden="true"
        focusable="false"
        role="presentation"
        style={{ opacity, flexShrink: 0, ...style }}
    >
        <path
            d="M40,150 L79,40 L118,150 C106,150 100,112 79,112 C58,112 52,150 40,150 Z"
            fill="none"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinejoin="round"
            strokeLinecap="round"
        />
    </svg>
);

export default ArchMark;
